import React, { Component } from "react";
import { BiSearch } from "react-icons/bi";
import { MdClose } from "react-icons/md";
import { Modal, ModalBody } from "reactstrap";
import Empty from "../../base/features/blocks/Empty";
import Image from "../../base/features/micro/Image";
import { categories } from "./services";

class CategoriesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      selectedCategory: null,
      key: "",
    };
  }
  componentDidMount() {
    this.getCategories();
  }
  getCategories() {
    categories().then((items) => {
      items && this.setState({ categories: items.results });
    });
  }
  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto h-75 max-h-75"
          isOpen={this.props.categoryModal}
          toggle={() => this.props.changeModal(!this.props.categoryModal)}
        >
          <ModalBody className="row mx-0 p-4">
            <div className="col-12 px-0">
              <div className="row mx-0 p-3 rounded14 border mb-4">
                <div className="col-auto px-0">
                  <BiSearch size={22} className="text-secondary" />
                </div>
                <div className="col px-2">
                  <input
                    className="w-100 h-100 p-0 border-0 fw-bold border-0"
                    placeholder="جستجو ..."
                    value={this.state.key}
                    onChange={(e) => this.setState({ key: e.target.value })}
                  />
                </div>
                {this.state.key && (
                  <div className="col-auto px-0">
                    <MdClose
                      size={26}
                      onClick={() => this.setState({ key: "" })}
                    />
                  </div>
                )}
              </div>
            </div>
            {this.state.categories
              .filter((person) => person.title.includes(this.state.key))
              .map((category, c) =>
                this.state.categories.length === 0 ? (
                  <Empty text="دسته بندی موجود نمی باشد" />
                ) : (
                  <div
                    className={
                      "col-4 px-0 my-3 py-1 rounded14 text-center " +
                      (this.props.category &&
                      category.uid === this.props.category.uid
                        ? "border-color-main"
                        : "")
                    }
                    onClick={() => {
                      this.props.categoryChange(category);
                      this.props.changeModal(false);
                    }}
                  >
                    <Image
                      imageUri={category.icon && category.icon.icon_128}
                      imgClassName="w-50 d-block mx-auto"
                      extraClassName="w-50 d-block rounded14 p-2 mx-auto bg-secondary"
                    />
                    <p className="mb-0 mt-2">{category.title}</p>
                  </div>
                )
              )}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default CategoriesModal;
